// Derives grammar info ONLY from what is already written in a vocabulary entry's `de`
// string (e.g. "die Beziehung, -en" or "aufgeben (gibt auf, gab auf, hat aufgegeben)").
// Nothing is guessed: if the source notation is absent, the field is left out.

export const ARTICLE_STYLES = {
  der: { gender: 'Mashkullore (maskulin)', className: 'text-blue-700 bg-blue-50 border-blue-200' },
  die: { gender: 'Femërore (feminin)', className: 'text-red-700 bg-red-50 border-red-200' },
  das: { gender: 'Asnjanëse (neutral)', className: 'text-green-700 bg-green-50 border-green-200' },
};

const SIMPLE_PLURAL = /^-(e|en|n|s|se|er|nen|ne)$/;

export function parseVocabEntry(de = '') {
  const raw = de.trim();

  // Verb with principal parts: "infinitive (präsens, präteritum, hat/ist partizip)"
  const verb = raw.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
  if (verb) {
    const parts = verb[2].split(',').map((p) => p.trim());
    const perfekt = parts[2] && /^(hat|ist)\s/.test(parts[2]) ? parts[2] : null;
    if (parts.length === 3 && perfekt) {
      return {
        kind: 'verb',
        word: verb[1].trim(),
        infinitive: verb[1].trim(),
        praesens: parts[0],
        praeteritum: parts[1],
        perfekt,
        auxiliary: perfekt.split(' ')[0] === 'ist' ? 'sein' : 'haben',
      };
    }
    // Schritte notation lists only the Perfekt: "an·sehen (hat angesehen)"
    if (parts.length === 1 && /^(hat|ist)\s\S+$/.test(parts[0])) {
      return {
        kind: 'verb',
        word: verb[1].trim(),
        infinitive: verb[1].trim(),
        praesens: null,
        praeteritum: null,
        perfekt: parts[0],
        auxiliary: parts[0].startsWith('ist') ? 'sein' : 'haben',
      };
    }
  }

  // Noun: "der|die|das Word[, plural-notation]"
  const noun = raw.match(/^(der|die|das)\s+([^,]+?)(?:,\s*(.+))?$/);
  if (noun && !noun[2].includes('/')) {
    const [, article, word, pluralNote] = noun;
    let plural = null;
    if (pluralNote) {
      const note = pluralNote.trim();
      if (note === '-') plural = `die ${word}`; // unchanged plural
      else if (SIMPLE_PLURAL.test(note)) plural = `die ${word}${note.slice(1)}`;
    }
    return {
      kind: 'noun',
      word,
      article,
      gender: ARTICLE_STYLES[article].gender,
      plural,
      pluralNote: pluralNote?.trim() || null,
    };
  }
  if (noun) {
    return { kind: 'noun', word: noun[2], article: noun[1], gender: null, plural: null, pluralNote: noun[3]?.trim() || null };
  }

  return { kind: 'other', word: raw };
}
